// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"dd96b055","455":"0fd0fab0","977":"318aebf3"}[chunkId] + ".chunk.js";
};